import {loadable} from 'router/routes';

import getInitialState from './redux/get-initial-state';

const Home = loadable(() => import('./Home'));

Home.getInitialState = getInitialState;

export default Home;
